import { WorkerWithProfile } from './workforce.data'
import { Performer } from './performers.data'
import { Exhibitor } from './exhibitors.data'
import { Sponsor } from './sponsors.data'
import { JoiResource } from './resources.data'
import { Program } from './programs.data'
import { OnsiteActivity } from './onsite.data'
import { Attendee } from './attendees.data'

export interface TagData {
  id: string
  title: string // to match photo component
  photoURL?: string // same
}


export interface BaseTagPanelData { workforceTags: TagData[], performerTags: TagData[], sponsorTags: TagData[], exhibitorTags: TagData[], resourceTags: TagData[], attendeeTags: TagData[] }
export interface TagPanelData extends BaseTagPanelData { count: number }

export type TagType = 'workforce' | 'performer' | 'sponsor' | 'exhibitor' | 'resource' | 'attendee'

export const getTagPanelData = (workforceTags: string[], performerTags: string[], sponsorTags: string[], exhibitorTags: string[], 
  workersByEmail: { [email:string]: WorkerWithProfile }, performers: { [id:string]: Performer }, sponsors: { [id:string]: Sponsor }, 
  exhibitors: { [id:string]: Exhibitor }, resourceTags: string[], resources: { [id:string]: JoiResource }, attendeeTags: string[], attendees: { [id: string]: Attendee }): TagPanelData => {
    const baseTagPanelData: BaseTagPanelData = {
      workforceTags: (workforceTags || [])
        .map(t => workersByEmail[t])
        .filter(w1 => w1)
        .map(({ email, photoURL, firstName, lastName }) => ({ id: email, photoURL, title: `${firstName || ''}${firstName && lastName ? ' ' : ''}${lastName || ''}`})),
      performerTags: (performerTags || [])
        .map(id => performers[id])
        .filter(p1 => p1).map(({ id, photoUrl, name }) => ({ id, photoURL: photoUrl, title: name })),
      sponsorTags: (sponsorTags || [])
        .map(id => sponsors[id])
        .filter(s1 => s1)
        .map(({ id, name, logoUrl }) => ({ id,  title: name, photoURL: logoUrl })),
      exhibitorTags: (exhibitorTags || [])
        .map(id => exhibitors[id])
        .filter(e1 => e1)
        .map(({ id, name, logoUrl }) => ({ id, title: name, photoURL: logoUrl })),
      resourceTags: (resourceTags || [])
        .map(id => resources[id])
        .filter(r1 => r1)
        .map(({ id, name, logoUrl }) => ({ id, title: name, photoURL: logoUrl })),
      attendeeTags: (attendeeTags || [])
        .map(id => attendees[id])
        .filter(r1 => r1)
        .map(({ id, name, photoUrl }) => ({ id, title: name, photoURL: photoUrl }))
    }
    const { workforceTags: w, performerTags: p, sponsorTags: s, exhibitorTags: e, resourceTags: r, attendeeTags: a } = baseTagPanelData
    return { ...baseTagPanelData, count: w.length + p.length + s.length + e.length + r.length + a.length}
  }

export const getAllTagPanelData = (programs: Program[], activities: OnsiteActivity[], 
  workersByEmail: { [email:string]: WorkerWithProfile }, performers: { [id:string]: Performer }, 
  sponsors: { [id:string]: Sponsor }, exhibitors: { [id:string]: Exhibitor }, 
  resources: { [id:string]: JoiResource }, attendees: { [id: string]: Attendee }, andPrograms = true): { [id:string]: TagPanelData } => {
  const tagPanelData: { [id:string]: TagPanelData } = {}
  programs.forEach(p => {
    const { workforceTags, performerTags, exhibitorTags, sponsorTags, resourceTags, attendeeTags } = p
    if (andPrograms) tagPanelData[p.id] = getTagPanelData(workforceTags, performerTags, sponsorTags, exhibitorTags, workersByEmail, performers, sponsors, exhibitors, resourceTags, resources, attendeeTags, attendees)
    p.sessions.forEach(programDay => programDay.sessions.forEach(sessionId => {
      // tslint:disable-next-line:no-shadowed-variable
      const { tags, performerTags, exhibitorTags, sponsorTags, resourceTags, attendeeTags } = p.sessions_obj[sessionId]
      tagPanelData[sessionId] = getTagPanelData(tags, performerTags, sponsorTags, exhibitorTags, workersByEmail, performers, sponsors, exhibitors, resourceTags, resources, attendeeTags, attendees)
    }))
  })
  if (activities) activities.forEach(a => {
    const { id, performerIds, resourceIds, exhibitorIds, tags, sponsorIds, attendeeIds } = a
    tagPanelData[id] = getTagPanelData(tags, performerIds, sponsorIds, exhibitorIds, workersByEmail, performers, sponsors, exhibitors, resourceIds, resources, attendeeIds, attendees)
  })
  return tagPanelData
}